import { defaultRender } from 'piral-core';
import { LanguagesPickerProps } from './types';

export const DefaultPicker: React.FC<LanguagesPickerProps> = props => defaultRender(undefined);
